import { persistentReducedStream, reducer } from 'rxbeach';
import { State } from 'types';
import { AuthBoundaryState } from '../types';
import { authError, authSuccess, login, logout, register } from './actions';

export const defaultState: AuthBoundaryState = {
  user: null,
  token: null,
  state: State.SUCCESS,
};

const authenticateReducer = reducer(
  [login, register],
  (prev: AuthBoundaryState) => ({
    ...prev,
    state: State.LOADING,
  })
);

const authSuccessReducer = reducer(
  authSuccess,
  (prev: AuthBoundaryState, { user, token }) => ({
    ...prev,
    user,
    token: token || null,
    state: State.SUCCESS,
  })
);

const authLogoutReducer = reducer(logout, () => defaultState);

const authErrorReducer = reducer<AuthBoundaryState>(authError, () => ({
  ...defaultState,
  state: State.ERROR,
}));

export const auth$ = persistentReducedStream('auth', defaultState, [
  authenticateReducer,
  authSuccessReducer,
  authLogoutReducer,
  authErrorReducer,
]);
